import { axios } from 'api'

const getNetSuiteSalesOrder = (orderNumber: string, company: string) =>
  axios.get(`/netsuite/sales-order`, {
    params: {
      orderNumber,
      company
    }
  })

const getProductBin = (url: string, locationId: number, company: string) =>
  axios.get(`/netsuite/product-bin`, {
    params: {
      url,
      locationId,
      company
    }
  })

const getNetSuitePurchaseOrder = (orderNumber: string, company: string) =>
  axios.get(`/netsuite/purchase-order`, {
    params: {
      orderNumber,
      company
    }
  })

const getNetSuiteTransferOrder = (orderNumber: string, company: string) =>
  axios.get(`/netsuite/find-transfer-order`, {
    params: { orderNumber, company }
  })

const getNetSuiteTransferOrderFba = (orderNumber: string, company: string) =>
  axios.get(`/netsuite/find-transfer-order-fba`, {
    params: { orderNumber, company }
  })

const submitPickingSalesOrder = (
  orderNumber: string,
  pickedItems: any[],
  locationId: string,
  company: string
) =>
  axios.post(`/netsuite/submit-picking`, {
    orderNumber,
    pickedItems,
    locationId,
    company
  })

const submitReceivingPurchaseOrder = (
  items: any,
  location: any,
  company: string,
  orderId: string
) =>
  axios.post(`/netsuite/submit-receiving`, {
    items,
    location,
    company,
    orderId
  })

const submitPickingTransferOrder = (
  orderId: string,
  pickedItems: any[],
  company: string
) =>
  axios.post(`/netsuite/submit-picking-transfer-order`, {
    orderId,
    pickedItems,
    company
  })

const printFBALabel = (FBANumber: string, itemSku: string) =>
  axios.get(`/netsuite/print-fba-label`, {
    params: {
      FBANumber,
      itemSku
    }
  })

const getNetSuiteLocations = (company: string) =>
  axios.get(`/netsuite/locations`, {
    params: {
      company
    }
  })

const getNetSuiteItemInventory = (
  company: string,
  itemCode: string,
  locationId: string
) =>
  axios.get(`/netsuite/item-inventory`, {
    params: {
      company,
      itemCode,
      locationId
    }
  })

const getBinsInLocation = (company: string, locationId: string) =>
  axios.get(`/netsuite/bins-in-location`, {
    params: { company, locationId }
  })

const adjustItemBinQuantities = (
  company: string,
  locationId: string,
  itemCode: string,
  quantity: number,
  fromBin: string,
  toBin: string,
  memo?: string
) =>
  axios.post(`/netsuite/adjust-item-bin-quantities`, {
    company,
    locationId,
    itemCode,
    quantity,
    fromBin,
    toBin,
    ...(memo !== undefined && memo !== '' && { memo })
  })

const setPreferredBin = (
  company: string,
  locationId: string,
  itemCode: string,
  binNumber: string
) =>
  axios.post(`/netsuite/set-preferred-bin`, {
    company,
    locationId,
    itemCode,
    binNumber
  })

export {
  getNetSuiteSalesOrder,
  getNetSuitePurchaseOrder,
  getNetSuiteTransferOrder,
  getNetSuiteTransferOrderFba,
  submitPickingSalesOrder,
  submitReceivingPurchaseOrder,
  getProductBin,
  submitPickingTransferOrder,
  printFBALabel,
  getNetSuiteLocations,
  getNetSuiteItemInventory,
  getBinsInLocation,
  adjustItemBinQuantities,
  setPreferredBin
}
